import React, { memo } from 'react';
import {
  useAddSlideToGroup,
  useDeleteSlidesFromSlideGroup,
} from 'components/SlideGroups/utilities/hooks';
import { checkIfSlideGroupContainSelectedSlides } from 'components/SlideGroups/utilities/utilities';
import { SlideGroupShortInfo } from 'components/SlideGroups/Modals/components/SlideGroupShortInfo';

export const SlideGroupItem = memo(
  ({ slideGroup, selectedSlides, classes }) => {
    const { addSlideToSlideGroup } = useAddSlideToGroup();
    const { deleteSlidesFromSlideGroup } = useDeleteSlidesFromSlideGroup();

    const isSlideGroupContainSlides = checkIfSlideGroupContainSelectedSlides(
      slideGroup,
      selectedSlides,
    );

    const handleSlideGroupClick = () => {
      (isSlideGroupContainSlides
        ? deleteSlidesFromSlideGroup
        : addSlideToSlideGroup)(slideGroup, selectedSlides);
    };

    return (
      <SlideGroupShortInfo
        key={slideGroup.uuid}
        slideGroup={slideGroup}
        customClasses={classes}
        hasSelectedSlides={isSlideGroupContainSlides}
        onClick={() => handleSlideGroupClick(slideGroup, selectedSlides)}
      />
    );
  },
);

SlideGroupItem.displayName = 'SlideGroupItem';
